import CancelIcon from '@/shared/assets/icons/canceledLead.svg?react'
import { BaseDialog } from '@/shared/components'

type Props = {
  modalConfirmation: boolean
  setModalCancel: (value: boolean) => void
  setModalConfirmation: (value: boolean) => void
}

export const CanceledPayout = ({
  setModalCancel,
  modalConfirmation,
  setModalConfirmation,
}: Props) => {
  return (
    <BaseDialog
      isVisible={modalConfirmation}
      onClose={() => setModalConfirmation(false)}
      onStepBack={() => {
        setModalConfirmation(false)
        setModalCancel(false)
      }}
      closeButtonName="Вернуться назад"
      xButton={false}
      iconTitle={<CancelIcon className="mx-auto text-[var(--status-red-fill)]" />}
    >
      <p className="text-[20px] text-center mt-[-8px]">Заявка отменена</p>
    </BaseDialog>
  )
}
